import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { saveConfig, updateSelectedOptions } from '../../FilterActions';
import { CustomSelect } from '../common';

class LocalDoneStatuses extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      selectedItems: [],
    };
  }

  componentDidMount() {
    this.updateState();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.items != this.props.items) {
      this.setState({
        items: this.props.items,
      });
    }

    if (prevProps.selectedItems != this.props.selectedItems) {
      this.setState({
        selectedItems: this.props.selectedItems,
      });
    }
  }

  updateState() {
    this.setState({
      items: this.props.items,
      selectedItems: this.props.selectedItems,
    });
  }

  handleChange = (value) => {
    const { items } = this.props;
    const selected = items.filter((i) => i.value._id === value);
    this.props.updateSelectedOptions(selected);
    this.props.saveConfig();
  };

  render() {
    const { items, selectedItems } = this.props;
    
    let values = [], value;
    if (items.length && selectedItems.length) {
      values = _.map(items, (i) => ({
        value: i.value._id,
        label: i.label,
      }));
      value = selectedItems[0].value._id;
    }
    
    return (
      <CustomSelect
        name={'doneStatus'}
        title={'Done Status'}
        items={values}
        value={value}
        onSelect={this.handleChange}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    saveConfig: () => dispatch(saveConfig()),
    updateSelectedOptions: (vals) => dispatch(updateSelectedOptions('dones', vals)),
  };
};

const mapStateToProps = (state) => {
  const chart = state.filters.chart;
  return {
    chart: state.filters.chart,
    items: state.filters.allDones,
    selectedItems: state.filters[chart].selectedDones,
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(LocalDoneStatuses);
export { connected as LocalDoneStatuses };
